import { 
    store, 
    getContext, 
    getElement,
    withScope,
    useState, 
    useEffect
} from '@wordpress/interactivity';


export const STORE_NAMESPACE = 'cwc/theme'


/** 
 * Sets up the default store for the CWC theme.
 * This includes state, actions, and callbacks for common functionality
 * such as sidebar toggling, sticky elements, and in-view tracking.
 */
const { state, callbacks } = store( STORE_NAMESPACE, {
    /** @type {any} */
    state: {},
    /** @type {any} */
    actions: {
        // sidebar toggle
        toggleSidebar: ( /** @type {any} */ event ) => {
            state.hasSidebarOpen = !state.hasSidebarOpen

            if ( state.hasSidebarOpen ) {
                callbacks.lockDocument()
            }
        },
        closeSidebar: ( /** @type {any} */ event ) => {
            const /** @type {any} */ { ref } = getElement()

            if ( state.hasSidebarOpen && !ref.contains( event.target ) ) {
                state.hasSidebarOpen = false
            }
        },
        closedSidebar: ( /** @type {any} */ event ) => {
            if ( !state.hasSidebarOpen ) {
                callbacks.unlockDocument()
            }
        }
    },
    /** @type {any} */
    callbacks: {
        // sticky
        setStickyAttributes: () => {
            /** @type {any} */
            const context = getContext( STORE_NAMESPACE )

            /** @type {any} */
            const { ref, attributes: {
                ['data-cwc-sticky']: stickyAttributes
            } } = getElement()


            /** @type {any} */
            const parsedAttributes = JSON.parse( stickyAttributes )
            const side = Object.keys( stickyAttributes ).find( key => [ 'top', 'bottom' ].includes( key ) )
            const type = getComputedStyle( ref ).position // get ref css position

            let top = null

            if ( type == 'sticky' ) {
                top = ref.offsetTop
            } else if ( type == 'fixed' ) {
                top = document.documentElement.scrollTop - document.documentElement.offsetTop
            }
            
            
            if ( top !== null ) {
                const breackPoint = top - parseInt( parsedAttributes?.[side] ?? 0 )

                context.isColored = breackPoint > context.stickyColorsPoint
            }
        },
    }
} )